// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Listings Grid */
.listing-grid__layout--default {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
}

.listing-grid__layout--artist {
  width: 100%;
  height: auto;
  overflow: hidden;
  -webkit-column-count: 2;
  -webkit-column-gap: 1.5em;
  -webkit-column-fill: auto;
  -moz-column-count: 2;
  -moz-column-gap: 1.5em;
  -moz-column-fill: auto;
  column-count: 2;
  grid-column-gap: 1.5em;
  column-gap: 1.5em;
  -webkit-column-fill: balance;
  column-fill: balance;
}

@media (max-width: 768px) {
  .listing-grid__layout--default {
    grid-template-columns: 1fr;
  }
  .listing-grid__layout--artist {
    -webkit-column-count: 1;
    -moz-column-count: 1;
    column-count: 1;
  }
}

.listing-grid__no-listings {
  color: #6b7280;
  font-size: 16px;
  text-align: center;
  padding: 60px 20px;
}

/* SEARCHABLE GRID */

/* .searchable-grid__container {
} */
`, "",{"version":3,"sources":["webpack://./src/components/page-layout/ListingGrid/ListingGrid.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,oBAAoB;;AAEpB;GACG","sourcesContent":["/* Listings Grid */\n.listing-grid__layout--default {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 24px;\n}\n\n.listing-grid__layout--artist {\n  width: 100%;\n  height: auto;\n  overflow: hidden;\n  -webkit-column-count: 2;\n  -webkit-column-gap: 1.5em;\n  -webkit-column-fill: auto;\n  -moz-column-count: 2;\n  -moz-column-gap: 1.5em;\n  -moz-column-fill: auto;\n  column-count: 2;\n  grid-column-gap: 1.5em;\n  column-gap: 1.5em;\n  -webkit-column-fill: balance;\n  column-fill: balance;\n}\n\n@media (max-width: 768px) {\n  .listing-grid__layout--default {\n    grid-template-columns: 1fr;\n  }\n  .listing-grid__layout--artist {\n    -webkit-column-count: 1;\n    -moz-column-count: 1;\n    column-count: 1;\n  }\n}\n\n.listing-grid__no-listings {\n  color: #6b7280;\n  font-size: 16px;\n  text-align: center;\n  padding: 60px 20px;\n}\n\n/* SEARCHABLE GRID */\n\n/* .searchable-grid__container {\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
